import radioGroup from './radio-group.vue'

radioGroup.install = function(Vue) {
  Vue.component(radioGroup.name, radioGroup)
}

export default radioGroup
